import React from "react";
import { NavLink } from "react-router-dom";
import { Nav } from "reactstrap";
import PerfectScrollbar from "perfect-scrollbar";

import LogoSistema from "../../components/LogoSistema/LogoSistema";

var ps;


class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.activeRoute.bind(this);
    this.sidebar = React.createRef();
  }
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.sidebar.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
  }
  render() {
    return (
      <div
        className="sidebar"
        data-color={"white"}
        data-active-color={"info"}
      >
        <div className="logo" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <LogoSistema identificacaoLogo={"logotipo"} style={{ maxHeight: '80px' }} />
          <LogoSistema identificacaoLogo={"logoSecundario"} width={"140"} style={{ maxHeight: '80px',marginTop: "-20px", marginBottom: "-30px" }} />
          <div className="pt-4">
            Gestão de Cadastros
          </div>
        </div>
        <div className="sidebar-wrapper" ref={this.sidebar}>
          <Nav style={{ marginBottom: "60px" }}>
            {this.props.routes.map((prop, key) => {
              return (
                <li
                  className={
                    this.activeRoute(prop.path) +
                    (prop.pro ? " active-pro" : "")
                  }

                  Style={prop.sidebar == true ? "display: block" : "display: none"}

                  key={key}
                >
                  <NavLink
                    to={prop.layout + prop.path}
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className={prop.icon} />
                    <p>{prop.name}</p>
                  </NavLink>
                </li>
              );
            })}
          </Nav>
        </div>
      </div>
    );
  }
}

export default Sidebar;
